import React, { useState, useRef, useEffect, useContext } from 'react';
import { PredictiveInput } from './PredictiveInput';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import {
  Wrapper,
  IconWrapper,
  Ubigeo,
  Placeholder,
  Content,
  IconClose,
  LoaderWrapper
 } from './styled';
import { PredictiveResults } from './PredictiveResults';
import { isClientEnv } from '@app/src/utils/validations';
import { PredictiveContext } from './PredictiveConstructor';

const isClient = isClientEnv();
const KEY_DOWN = 40;
const KEY_UP = 38;
const ESC = 27;
const ENTER = 13;

export const PredictiveInputCustom: React.FC = () => {

  const {
    handleChange,
    handleClickClose,
    handleChangeInput,
    error,
    handleBlurInput,
    defaultUbigeo,
    disabled,
    isLoading
  } = useContext(PredictiveContext);
  const [suggestionsList, setSuggestionsList] = useState([]);
  const [currentValue, setCurrentValue] = useState('');
  const [activeSuggestion, setActiveSuggestion] = useState(-1);
  const [formatValue, setFormatValue] = useState([]);
  const [value, setValue] = useState('');
  const refWrapper = useRef(null);
  const refClose = useRef(null);
  let refInput = null;
  let refItems = null;

  useEffect(() => {
    if (value) {
      let formatValue = value.split(',');
      setFormatValue(formatValue)
    }
  }, [value])

  useEffect(() => {
    if (defaultUbigeo) {
      setValue(defaultUbigeo);
      setCurrentValue(defaultUbigeo);
      refInput.current.style.display ='none';
    } else {
      setValue('');
      setCurrentValue('');
      refInput.current.style.display ='block';
    }
  }, [defaultUbigeo]);

  useEffect(() => {
    if(isClient) {
      if(suggestionsList.length > 0) {
        document.addEventListener('click', handleCloseSuggestion);
      }
      return () => {
        document.removeEventListener('click', handleCloseSuggestion);
      };
    }
  }, [suggestionsList]);

  useEffect(() => {
    if(suggestionsList[activeSuggestion]) {
      setCurrentValue(suggestionsList[activeSuggestion].data.location);
      setValue(suggestionsList[activeSuggestion].data.location);
      refItems[activeSuggestion].current.focus();
      refInput.current.style.display ='none';
    }
    if(activeSuggestion < 0) {
      setSuggestionsList([]);
    }

  }, [activeSuggestion]);

  const handleCloseSuggestion = (e: MouseEvent) => {
    if(!refWrapper.current.contains(e.target)) {
      setSuggestionsList([]);
    }
  }

  const handleClickClear = () => {
    handleClickClose && handleClickClose();
    refInput.current.style.display = 'block';
    setCurrentValue('');
    setValue('');
    setActiveSuggestion(-1);
    refInput.current.focus();
  }

  const handleClickSuggestion = (indexActive: number) => {
    setActiveSuggestion(indexActive);
    refInput.current.style.display ='none';
    handleChange && handleChange(suggestionsList[indexActive]);
    setTimeout(() => {
      setSuggestionsList([]);
      setActiveSuggestion(-1);
    }, 100);
  }

  const handleKeyDownInput = (e: React.KeyboardEvent) => {
    const keyCode = e.keyCode || e.which;
    if(keyCode === KEY_DOWN) {
      if(suggestionsList.length) {
        setActiveSuggestion(0);
      }
    }
    if(keyCode === ENTER) {
      e.preventDefault();
      setSuggestionsList([]);
    }
  }

  const handleKeyDownList = (e: React.KeyboardEvent) => {
    e.preventDefault();
    const keyCode = e.keyCode || e.which;
    if(keyCode === KEY_DOWN) {
      if(activeSuggestion < suggestionsList.length - 1) {
        setActiveSuggestion(activeSuggestion + 1);
      }
    }
    if(keyCode === KEY_UP) {
      setActiveSuggestion(activeSuggestion - 1);
    }
    if(keyCode === ENTER) {
      handleChange && handleChange(suggestionsList[activeSuggestion]);
      setTimeout(() => {
        setSuggestionsList([]);
        setActiveSuggestion(-1);
      }, 100);
    }
    if(keyCode === ESC) {
      setSuggestionsList([]);
    }
  }

  const handleBlur = () => {
    if(activeSuggestion === -1) {
      setCurrentValue('');
      setValue('');
      handleChange && handleChange(null);
      handleBlurInput && handleBlurInput();
    }
  }

  const handleChangeProp = (value: string) => {
    setCurrentValue(value)
  }

  return(
    <Content>
      <Wrapper
        ref={refWrapper}
        borderColor={`1px solid ${error ? 'red' : COLORS.GRAY}`}
      >
        <IconWrapper>
          <Icon data-name="icon-map" width="18" height="18" fill={COLORS.GRAY_PLACEHOLDER} />
        </IconWrapper>
        <PredictiveInput
          disabled={disabled || isLoading}
          handleRef={ref => { refInput = ref}}
          value={currentValue}
          getResults={results => setSuggestionsList(results)}
          handleChange={handleChangeProp}
          handleChangeInput={handleChangeInput}
          handleBlur={handleBlur}
          handleKeyDown={e => handleKeyDownInput && handleKeyDownInput(e)}
        />
        {
          (currentValue === '' && value === '') &&
            <Placeholder>
              <span>Ej. Miraflores</span>, Lima, Lima
            </Placeholder>
        }
        {
          (currentValue && currentValue === value) &&
            <Ubigeo>
              <span>{formatValue[0]}</span>{formatValue[1] ? `, ${formatValue[1]}` : ''}{formatValue[2] ? `, ${formatValue[2]}` : ''}
            </Ubigeo>
        }
        {
          (currentValue !== '' || value !== '') && !disabled &&
            <IconClose onClick={handleClickClear} ref={refClose}>
              <Icon data-name="icon-close-bold" width="18" height="18" fill={COLORS.GRAY} />
            </IconClose>
        }
        {
          isLoading &&
          <LoaderWrapper>
              <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
          </LoaderWrapper>
        }
      </Wrapper>
      {
        suggestionsList && suggestionsList.length > 0 &&
        <PredictiveResults
          dataList={suggestionsList}
          showFirstItems={5}
          handleClickItem={handleClickSuggestion}
          handleRefItems={refs => { refItems = refs }}
          handleKeyDown={handleKeyDownList}
        />
      }
    </Content>
)};
